module.exports = __webpack_public_path__ + "5f335a380c9610e35cb1db1b31ec9b62.svg";